import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const CopyButton = ({ value, textToCopy, size = 'small' }) => {
  const [copied, setCopied] = useState(false);

  // Support both 'value' and 'textToCopy' props for backward compatibility
  const textToUse = textToCopy || value;

  const handleCopy = () => {
    // Check if we have valid text to copy
    if (!textToUse || textToUse === 'undefined' || textToUse === 'null') {
      console.warn('CopyButton: No valid text to copy', { textToUse, value, textToCopy });
      return;
    }

    navigator.clipboard.writeText(textToUse)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch((error) => {
        console.error('Failed to copy text:', error);
        // Fallback method
        try {
          const textArea = document.createElement('textarea');
          textArea.value = textToUse;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        } catch (fallbackError) {
          console.error('Fallback copy also failed:', fallbackError);
        }
      });
  };

  // Don't render the button if there's no valid text
  if (!textToUse || textToUse === 'undefined' || textToUse === 'null') {
    return null;
  }

  return (
    <Tooltip title={copied ? "Copied!" : "Copy address"}>
      <IconButton
        onClick={handleCopy}
        size={size}
        sx={{
          padding: '2px',
          marginLeft: '4px',
          color: 'rgba(0, 0, 0, 0.5)',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
          }
        }}
      >
        <ContentCopyIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  );
};

export default CopyButton;